import React, { useEffect } from 'react';
import { BrowserRouter, Route, Routes, useLocation } from 'react-router-dom';
import { LanguageProvider } from './contexts/LanguageContext';
import { CartProvider } from './contexts/CartContext';
import { Navbar } from './components/Navbar';
import { Footer } from './components/Footer';
import { Home } from './pages/Home';
import { Recettes } from './pages/Recettes';
import { Evenements } from './pages/Evenements';
import { Contact } from './pages/Contact';
import { Panier } from './pages/Panier';
import { Remboursement } from './pages/Remboursement';

/** Scrolls to the hash target on navigation, or back to the top of a new page. */
function ScrollManager() {
  const {
    pathname,
    hash
  } = useLocation();
  useEffect(() => {
    if (hash) {
      const target = document.querySelector(hash);
      if (target) {
        target.scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        });
        return;
      }
    }
    window.scrollTo({
      top: 0,
      behavior: 'auto'
    });
  }, [pathname, hash]);
  return null;
}
export function App() {
  return <LanguageProvider data-id="element-0" data-mp="3ihv1ac76whht">
      <CartProvider data-id="element-1" data-mp="3mlavl1vse5rc">
        <BrowserRouter data-id="element-2" data-mp="3mkrc3gqhn9b7">
          <ScrollManager data-id="element-3" data-mp="3mjzsl4a6121a" />
          <div className="min-h-screen w-full bg-creme font-sans text-cacao-900" data-id="element-4" data-mp="3mjgclt42snpw">
            <Navbar data-id="element-5" data-mp="3rd1a7k1rbfok" />
            <main data-id="element-6" data-mp="3relw6la09qat">
              <Routes data-id="element-7" data-mp="5os92t1uy7l">
                <Route path="/" element={<Home data-id="element-9" data-mp="5ggxfcks0yi" />} data-id="element-8" data-mp="4wv3njt0sf7" />
                <Route path="/recettes" element={<Recettes data-id="element-11" data-mp="2zllijblcf2rh" />} data-id="element-10" data-mp="7stfczkdj46" />
                <Route path="/evenements" element={<Evenements data-id="element-13" data-mp="2zng1wlgyumtg" />} data-id="element-12" data-mp="2zmo3z3zwcd00" />
                <Route path="/contact" element={<Contact data-id="element-15" data-mp="33n6y54p9hv5d" />} data-id="element-14" data-mp="33lwyib2rgewm" />
                <Route path="/panier" element={<Panier data-id="element-17" data-mp="38l8hlqqlnwhd" />} data-id="element-16" data-mp="33oi0r16z0wuw" />
                <Route path="/remboursement" element={<Remboursement data-id="element-19" data-mp="38o4fjf2g6l5t" />} data-id="element-18" data-mp="38l017ov9q91f" />
                <Route path="*" element={<Home data-id="element-21" data-mp="3dlnwwnufze1z" />} data-id="element-20" data-mp="3dl4l7ovdxlwe" />
              </Routes>
            </main>
            <Footer data-id="element-22" data-mp="nw2e2bl1k0tq" />
          </div>
        </BrowserRouter>
      </CartProvider>
    </LanguageProvider>;
}